import T from "../theme/colors";

export default function Card({ children, style = {}, padding, title, subtitle, actions }) {
  return (
    <div style={{
      background: "var(--bg-card)",
      border: `1px solid var(--border)`,
      borderRadius: 10,
      boxShadow: "var(--shadow-sm)",
      overflow: "hidden",
      ...style,
    }}>
      {(title || actions) && (
        <div style={{
          padding: "14px 20px",
          borderBottom: `1px solid var(--border)`,
          display: "flex", alignItems: "center", justifyContent: "space-between",
          background: "var(--bg-input)",
        }}>
          <div>
            {title && (
              <h3 style={{ fontSize: 15, fontWeight: 600, color: "var(--text-0)", fontFamily: "var(--font-ui)" }}>
                {title}
              </h3>
            )}
            {subtitle && <p style={{ fontSize: 13, color: "var(--text-2)", marginTop: 1 }}>{subtitle}</p>}
          </div>
          {actions && <div style={{ display: "flex", gap: 8 }}>{actions}</div>}
        </div>
      )}
      <div style={padding !== undefined ? { padding } : {}}>
        {children}
      </div>
    </div>
  );
}